import { Component, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { timer } from 'rxjs/observable/timer';

//Servicios
import { DefaultService } from '../../services/default.service';

@Component({
  selector: 'app-idiomas',
  templateUrl: './idiomas.component.html',
  styleUrls: ['./idiomas.component.css']
})
export class IdiomasComponent implements OnInit {
  public user:any = {};
  public showAviso:boolean = false;
  
  constructor(
    public _defaultService: DefaultService,
    public translate: TranslateService,
  ) { 
    this.user = localStorage.getItem('UsersSesion');
  }

  ngOnInit() {

  }

  
  idioma(idioma){
    if(this.user != null && this.user != undefined){
        this._defaultService.updateIdioma(this.user, idioma);
    }

    localStorage.setItem('idioma', idioma);

    this.translate.use(idioma);
    this.showIdioma();
  }

  showIdioma(){
    this.showAviso = true;
    timer(2000).subscribe(() => this.showAviso = false);
  }
}



// WEBPACK FOOTER //
// ./src/app/idiomas/idiomas.component.ts